import type { SlideBlock } from '@ps/web-martech-cms-types/Carousel';
import React from 'react';

import { CMSImage, CMSLinkedImage } from '@swf/cms';

const DefaultCarouselItem: React.FC<SlideBlock> = ({ slide }) =>
  slide.link.url ? (
    <CMSLinkedImage {...slide} />
  ) : (
    <CMSImage {...slide.image} logged_in_image={slide?.logged_in_linked_image?.image} />
  );

export default DefaultCarouselItem;
